import { Dialog, DialogContent } from '@mui/material';
import { FC, useContext, useState } from 'react';
import { AppContext } from 'templates/AppContextProvider';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { TermsParser } from 'organisms/u002/TermsParser';
import { Form } from 'templates/Form';
import LoadingModal from 'organisms/LoadingModal';
import { useGetAuditionConsentHooks } from 'hooks/u005/useGetAuditionConsentHooks';
import MessageModal from 'organisms/MessageModal';
import { TransitionButton } from 'atoms/TransitionButton';

type SpecificUseConsentProps = {
  auditionId: string;
  onComplete: () => void;
};
export const SpecificUseConsent: FC<SpecificUseConsentProps> = (props) => {
  const { t: tAuditionInfo } = useTranslationWithLang('auditionInfo');
  const [open, setOpen] = useState(true);
  const { currentLang } = useContext(AppContext);
  const [data, loading, err] = useGetAuditionConsentHooks({
    lang: currentLang,
    audition_id: props.auditionId,
    consent_type: '2', // 2: 特定利用同意
  });
  const [errorMessage, setErrorMessage] = useState('');

  if (err && !loading) {
    return (
      <MessageModal
        message={tAuditionInfo('TU005_027')}
        closeLabel={tAuditionInfo('TU005_024')}
        onClose={() => {
          setErrorMessage('');
          props.onComplete();
        }}
      />
    );
  }

  return (
    <>
      {errorMessage && (
        <MessageModal
          message={errorMessage}
          closeLabel={tAuditionInfo('TU005_024')}
          onClose={() => setErrorMessage('')}
        />
      )}
      <Dialog
        open={open}
        maxWidth="sm"
        fullWidth
        aria-labelledby="specific-use-consent-dialog"
        PaperProps={{
          style: {
            color: 'var(--c-text)',
            padding: '4px',
            borderRadius: '10px',
            backgroundColor: 'var(--c-background2)',
            boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        {loading && <LoadingModal />}
        <DialogContent sx={{ padding: '0px' }}>
          <Form title={tAuditionInfo('TU005_025')}>
            <h2 id="specific-use-consent-dialog" className="sr-only">
              {tAuditionInfo('TU005_025')}
            </h2>
            <div className="max-h-96 overflow-y-scroll my-10">
              <TermsParser text={data?.consent ?? ''} />
            </div>
          </Form>
          <div className="flex justify-center">
            <TransitionButton
              label={tAuditionInfo('TU005_024')}
              onClick={() => {
                setOpen(false);
                props.onComplete();
              }}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
